import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitBeatList'
})
export class SplitBeatListPipe implements PipeTransform {

  transform(beatsList: any, parts: number): Array<any> {
    return this.splitIntoParts(beatsList, parts);
  }

  /**
   *  Split Array
   * @param arr 
   * @param parts 
   * @returns 
   */
  splitIntoParts(arr: Array<any>, parts: number): Array<any> {
    const result: Array<[][]> = [];
    for (let i = 0; i < arr.length; i += parts) {
      result.push(arr.slice(i, i + parts));
    }
    return result;
  }

}
